module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$auth.ready()) ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "columns is-centered is-gapless",
    staticStyle: {
      "margin-top": "3rem"
    }
  }, [_c('div', {
    staticClass: "column is-4"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('h2', {
    staticClass: "is-title is-bold has-text-centered has-text-primary"
  }, [_vm._v("\n          ChangeVU Free Trial Login\n        ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error),
      expression: "error"
    }],
    staticStyle: {
      "color": "red",
      "word-wrap": "break-word"
    }
  }, [_vm._v(_vm._s(_vm.error))]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.login($event)
      }
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Email")]), _vm._v(" "), _c('p', {
    staticClass: "control has-icon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "name@example.com"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Password")]), _vm._v(" "), _c('p', {
    staticClass: "control has-icon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "input",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _vm._m(3)])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "control has-text-centered",
    staticStyle: {
      "margin-top": "1rem"
    }
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Login")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "control has-text-centered",
    staticStyle: {
      "margin-top": "1rem"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/forgotPassword"
    }
  }, [_vm._v("Forgot Password")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cda19f0c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/auth/Login.vue
// module id = 384
// module chunks = 5